var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File icons 24px/MORE",
    clipPath: "url(#clip0_62488_125529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15H17C15.8954 15 15 15.8954 15 17V21H5C3.89543 21 3 20.1046 3 19V5ZM21 17C21 19.2091 19.2091 21 17 21V17H21ZM6.64 10.16C6.64 10.692 7.039 11.07 7.564 11.07C8.089 11.07 8.488 10.692 8.488 10.16C8.488 9.621 8.089 9.264 7.564 9.264C7.039 9.264 6.64 9.621 6.64 10.16ZM10.8646 10.16C10.8646 10.692 11.2636 11.07 11.7886 11.07C12.3136 11.07 12.7126 10.692 12.7126 10.16C12.7126 9.621 12.3136 9.264 11.7886 9.264C11.2636 9.264 10.8646 9.621 10.8646 10.16ZM15.0892 10.16C15.0892 10.692 15.4882 11.07 16.0132 11.07C16.5382 11.07 16.9372 10.692 16.9372 10.16C16.9372 9.621 16.5382 9.264 16.0132 9.264C15.4882 9.264 15.0892 9.621 15.0892 10.16Z",
    fill: "#E264BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62488_125529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.0d009f0d8118a67a13f25fe856e762a3.svg";
export { ForwardRef as ReactComponent };